import React, { useRef, useState } from 'react';
import { useBreakpoint, Accordion } from 'basis';

const DEFAULT_LABEL = 'Things to know before you start';

export const AccordionAtXS = ({ label = DEFAULT_LABEL, size = 'small', children }) => {
  const breakpoint = useBreakpoint();
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  // default: 0-374px, xs: 375px-575px,
  if (breakpoint !== 'default' && breakpoint !== 'xs') {
    return children;
  }

  return (
    <Accordion isOpen={isOpen} itemHeaderAs="subtitle2">
      <Accordion.Item>
        <Accordion.Item.Header onClick={toggleAccordion}>{label}</Accordion.Item.Header>
        <Accordion.Item.Content ref={contentRef}>{children}</Accordion.Item.Content>
      </Accordion.Item>
    </Accordion>
  );
};
